import { Link } from "react-router-dom";
import { LinkedinLogo, InstagramLogo, FacebookLogo } from "@phosphor-icons/react";

const columns = [
    {
        title: "Company",
        links: [
            { label: "About", to: "/about", testid: "footer-about" },
            { label: "How It Works", to: "/#how-it-works", testid: "footer-how-it-works" },
            { label: "Specialties", to: "/#specialties", testid: "footer-specialties" },
        ],
    },
    {
        title: "Ecosystem",
        links: [
            { label: "For Hospitals", to: "/partner", testid: "footer-hospitals" },
            { label: "Partner With Us", to: "/partner", testid: "footer-partner" },
            { label: "Contact", to: "/contact", testid: "footer-contact" },
        ],
    },
    {
        title: "Legal",
        links: [
            { label: "Privacy Policy", to: "/privacy", testid: "footer-privacy" },
            { label: "Terms of Use", to: "/terms", testid: "footer-terms" },
        ],
    },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-brand-blue text-white noise-overlay">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <img src="/images/logo.png" alt="GoMedVoyage" className="h-12 w-auto bg-white rounded-2xl px-4 py-2" />
                        <p className="mt-6 font-heading text-xl font-semibold">Healthcare Without Borders.</p>
                        <p className="mt-2 text-sm text-white/60">One intelligent journey from diagnosis to recovery.</p>
                        <div className="mt-6 flex gap-3">
                            {[
                                { Icon: LinkedinLogo, label: "LinkedIn", testid: "social-linkedin" },
                                { Icon: InstagramLogo, label: "Instagram", testid: "social-instagram" },
                                { Icon: FacebookLogo, label: "Facebook", testid: "social-facebook" },
                            ].map(({ Icon, label, testid }) => (
                                <a
                                    key={label}
                                    data-testid={testid}
                                    href={`https://www.${label.toLowerCase()}.com`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={label}
                                    className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:text-white hover:border-brand-green-light hover:bg-white/10 transition-colors duration-200"
                                >
                                    <Icon size={18} />
                                </a>
                            ))}
                        </div>
                    </div>
                    {columns.map((col) => (
                        <div key={col.title} className="md:col-span-2">
                            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-brand-green-light">{col.title}</h4>
                            <ul className="mt-5 space-y-3">
                                {col.links.map((l) => (
                                    <li key={l.label}>
                                        <Link data-testid={l.testid} to={l.to} className="text-sm text-white/70 hover:text-white transition-colors duration-200">
                                            {l.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-16 pt-8 border-t border-white/10">
                    <p data-testid="footer-disclaimer" className="text-xs leading-relaxed text-white/50 max-w-4xl">
                        GoMedVoyage is a healthcare navigation and facilitation platform and does not itself provide medical diagnosis or treatment.
                        Medical care is provided independently by qualified healthcare professionals and healthcare institutions. Availability of
                        healthcare services varies by location and provider.
                    </p>
                    <p className="mt-4 text-xs text-white/40">© 2026 GoMedVoyage. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}
